export const normalizeInput = `
  font-family: inherit;
  font-size: inherit;
  padding: 0;
  margin: 0;
  text-align: left;
  appearance: none;
  border: 0;
  border-radius: 0;
  caret-color: auto;
  background-color: transparent;
  &::placeholder{}
  &::-ms-expand{}
  &:focus{}
`

export const normalizeButton = `
  appearance: none;
  border: 0;
  background: none;
  padding: 0;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
`
